export enum SampleStatus {
  NOT_FIND = 4,
  REJECTED = 3,
  NOT_STARTED = 1,
  STARTED = 2,
  FINISHED = 0,
}
